const { ActionTypes } = require("../constants/action_types");

const initialState = 1;

export const updateProjectListReducer = (state = initialState, { type }) => {

    switch (type) {
        case ActionTypes.UPDATE_PROJECT_LIST:
            return state = state+1; //sidebarShow 
        default:
            return state;
    }
};
